import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementContextType } from "../../../../types";
import { toWSDateString, WSPillProps } from "@wingspanhq/fe-component-library";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { selectorIsRequirementReadyToSignAsPayee } from "../../../../selectors/selectorIsRequirementReadyToSignAsPayee";
import { extendRequirementStatusSecondaryText } from "../../../../helpers/extendRequirementStatusSecondaryText";
import { extendRequirementStatusPill } from "../../../../helpers/extendRequirementStatusPill";

export const getSignaturePayeeRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  signedDocument: ISignedDocumentResponse | undefined
): { pill: WSPillProps; secondaryText?: string } => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  const isRequirementReadyToSignAsPayee =
    selectorIsRequirementReadyToSignAsPayee(requirement, signedDocument);

  if (requirement.status === RequirementStatus.Complete) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };

    secondaryText =
      signedDocument?.events?.payerSignedAt || signedDocument?.updatedAt
        ? toWSDateString(
            signedDocument?.events?.payerSignedAt || signedDocument?.updatedAt,
            "monthDayYear"
          )
        : "";
  } else if (isRequirementReadyToSignAsPayee) {
    pill = {
      theme: "warning",
      text: "Action required",
      icon: true
    };
    secondaryText = "Awaiting your signature";
  } else {
    pill = {
      theme: "neutral",
      text: "Awaiting client",
      icon: "time"
    };
    secondaryText = "Awaiting client signature";
  }

  return {
    pill: extendRequirementStatusPill(
      requirement,
      RequirementContextType.Payer,
      pill
    ),
    secondaryText: extendRequirementStatusSecondaryText(
      requirement,
      RequirementContextType.Payer,
      secondaryText
    )
  };
};
